interface TeamMember {
  name: string;
  title: string;
  avatarUrl: string;
}

export const teamData: TeamMember[] = [
  {
    name: "Maria G. Zapata",
    title: "Líder / Directora Creativa",
    avatarUrl: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wzNjAzNTV8MHwxfHNlYXJjaHwxfHx3b21hbiUyMHBvcnRyYWl0JTIwYnVzaW5lc3N8ZW58MHx8fHwxNzI1NTE5MDM1fDA&ixlib=rb-4.0.3&q=80&w=1080",
  },
  {
    name: "Karen A. Altamar",
    title: "Gestor de Contenidos / Diseñador",
    avatarUrl: "https://images.unsplash.com/photo-1554151228-14d9def656e4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wzNjAzNTV8MHwxfHNlYXJjaHwyfHx3b21hbiUyMHBvcnRyYWl0fGVufDB8fHx8MTcyNTUxOTE0NHww&ixlib=rb-4.0.3&q=80&w=1080",
  },
  {
    name: "Andres J. Celis",
    title: "Desarrollador",
    avatarUrl: "https://aj-cybersecurity.com/wp-content/uploads/2025/09/IMG_3236_Original-removebg-preview.png",
  },
];
